import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { AspectRatio, Box, Flex, Image, useMultiStyleConfig, useTab, VisuallyHidden, useMediaQuery, Button, } from '@chakra-ui/react';
import { ThemeRadiusVariable, ThemeSpaceVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
/**
 * Custom Tab component used internally within Tab.tsx when the tab has
 * an image (true when property imgSrc is provided).
 *
 * For more info on custom tab components @see https://chakra-ui.com/docs/components/tabs/usage#creating-custom-tab-components
 */
export const CustomTabWithImage = React.forwardRef((props, ref) => {
    const [isLargerThan48em] = useMediaQuery('(min-width: 48em)'); // Larger than 'medium' breakpoint
    const imageSize = isLargerThan48em ? '96px' : '72px';
    const { imgAlt, imgSrc, imgFallbackColor, children, isDisabled } = props;
    // Get tab html props with tabs context (providing disabled info) with the useTab-hook
    const partialProps = { isDisabled };
    const tabHtmlProps = useTab({
        ...partialProps,
        ref,
    });
    // Hook onto the Tab theme, providing size and variant to get the right appearance
    const tabThemeConfig = useMultiStyleConfig('Tabs', {
        variant: 'default',
        size: isLargerThan48em ? 'md' : 'sm',
    });
    const imageFallback = imgFallbackColor ? (_jsx(Box, { bg: imgFallbackColor, w: imageSize, minW: imageSize, h: imageSize, minH: imageSize, borderRadius: ThemeRadiusVariable.Medium })) : undefined;
    return (_jsxs(Button, { variant: "unsyled", isDisabled: isDisabled, __css: tabThemeConfig.tabWithImage, ...tabHtmlProps, children: [_jsx(VisuallyHidden, { children: children }), _jsxs(Flex, { direction: "column", align: "center", role: "group", children: [_jsx(AspectRatio, { ratio: 1, maxWidth: imageSize, minWidth: imageSize, mb: ThemeSpaceVariable.XSmall, children: _jsx(Image, { src: imgSrc, alt: imgAlt, h: imageSize, w: imageSize, userSelect: "none", borderRadius: ThemeRadiusVariable.Medium, fallback: imageFallback }) }), _jsx(Box, { outline: "none", 
                        // Apply the tab styles, including selected style and disabled styles through data-attributes
                        // We don't apply aria-attributes, as those are reserved for real buttons (and this is a div)
                        __css: tabThemeConfig.tab, "data-selected": tabHtmlProps['aria-selected'] ? true : undefined, "data-disabled": isDisabled ? true : undefined, children: children })] })] }));
});
//# sourceMappingURL=tabWithImage.js.map